import React, { useState } from "react";
import { Star } from "lucide-react";

export function StarRating({ value = 0, onChange, size = "h-6 w-6", testid }) {
  const [hover, setHover] = useState(0);
  return (
    <div className="inline-flex gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => onChange(n === value ? 0 : n)}
          onMouseEnter={() => setHover(n)}
          onMouseLeave={() => setHover(0)}
          className="transition-transform hover:scale-110 focus:outline-none"
          data-testid={testid ? `${testid}-${n}` : undefined}
        >
          <Star className={`${size} ${n <= (hover || value) ? "fill-amber-400 text-amber-400" : "text-muted-foreground/30"}`} />
        </button>
      ))}
    </div>
  );
}
